<template>
  <div class="modal" :class="{ 'modal-open': $store.state.modalOpened }" v-show="$store.state.modalOpened" @click.self="hideModal()">
    <div class="modal-dialog b-shadow" >
      <div class="modal-content">
        <header class="modal-header">
          <div class="modal-logo mb-2">
            <img src="@/assets/images/logo.svg" alt="Magazyn Pismo"/>
          </div>
        </header>
        <div class="modal-body">
          <ValidationObserver
            autocomplete="off"
            tag="form"
            v-slot="{ handleSubmit }"
            @submit.prevent
          >
            <div class="mb-3">
              <label for="signInEmail" class="label">{{ $content.your_email }}:</label>
              <ValidationProvider rules="required" v-slot="{ errors }">
                <input
                  autocomplete="off"
                  id="signInEmail"
                  type="text"
                  class="form-control"
                  v-model="userEmail">
                <p class="form-error">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>

            <div class="mb-3">
              <label for="signInPassword" class="label">{{ $content.password }}:</label>
              <ValidationProvider rules="required" v-slot="{ errors }">
                <input
                  autocomplete="off"
                  id="signInPassword"
                  type="password"
                  class="form-control"
                  v-model="userPassword">
                <p class="form-error">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>

            <div>
              <p v-show="showError" class="c-pink mb-2">{{ $content.wrong_credentials }}</p>
              <button
                @click="handleSubmit(signIn)"
                type="submit"
                class="btn btn-primary btn-max">
                {{ $content.sign_in }}
              </button>
            </div>
          </ValidationObserver>
        </div>
        <footer class="modal-footer pb-1 pt-5">
          <div class="flex flex-space-between">
            <router-link
              @click.native="hideModal"
              class="c-gray t-small-caps"
              to="/resetuj_haslo/">{{ $content.forgot_password}}</router-link>
            <a class="c-pink t-uppercase t-bold" href="/rejestracja/?rel=/">{{ $content.sign_up }}</a>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
  import { ValidationProvider, ValidationObserver  } from 'vee-validate';
  import UserDataMixin from '../mixins/userdata';

  export default {
    name: 'SignInPopup',
    mixins: [ UserDataMixin ],
    components: {
      ValidationProvider,
      ValidationObserver
    },
    data() {
      return {
        userEmail: '',
        userPassword: '',
        showError: false
      }
    },
    methods: {
      hideModal() {
          this.$store.state.modalOpened = false;
      },
      signIn() {
        let formData = new FormData();
        formData.append('log', this.userEmail);
        formData.append('pwd', this.userPassword);

        this.$http.post('/wp-login.php', formData)
          .then(res => {
            if (res.status === 200) {
              if ( res.data.indexOf("sign-out") !== -1) {
                this.$store.state.modalOpened = false;
                this.$store.commit('setUserName', { name: this.userEmail });
                this.$store.dispatch('signIn');
                this.fetchUserData();
              } else {
                this.showError = true;
              }
            } else {
              this.showError = true;
            }
          })
          .catch(err => {
            this.showError = true;
          });

      },
    }
  }
</script>

<style scoped lang="scss">
  .modal {
    background: rgba(0,0,0,.15);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100%;
    height: 100%;
    outline: 0;
    overflow: hidden;
    padding: 10px;
    opacity: 0;
    &.modal-open {
      opacity: 1;
    }
    &-dialog {
      border: 1px solid var(--color-lightgray);
      max-width: 450px;
      background: var(--color-white);
      margin: 0 auto;
      padding: 15px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
    &-logo {
      max-width: 100px;
      margin: 0 auto;
    }
  }

  .btn-max {
    max-width: 450px !important;
  }
</style>
